import { formatTooltipValue } from '../format-chart-tool-tip';

import { TabType } from '@/routes/dashboards/shared-types';

import type { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';

export const BasicTooltipContentFormatterWrapper = (initialTab: TabType) => {
  const formatter = (value: ValueType, name: NameType, props: any) => {
    const typedProps = props as { color?: string };
    return (
      <div className="flex justify-between items-center w-full gap-4">
        <div className="flex items-center gap-2">
          <div
            className="w-2.5 h-2.5 rounded-[2px]"
            style={{ backgroundColor: typedProps.color }}
          />
          <span className="text-muted-foreground">{name}</span>
        </div>
        <span className="flex font-mono font-medium">{formatTooltipValue(value, initialTab)}</span>
      </div>
    );
  };

  return formatter;
};
